import React from 'react';

const HeroSection = () => {
  return (
    <div className="text-center bg-gray-50 py-20">
      <h1 className="text-5xl font-bold text-gray-800 mb-4">
        Your Personal Recipe Assistant
      </h1>
      <p className="text-xl text-gray-600 mb-8">
        Discover delicious global cuisines 🌏🍲 with ease and create
        mouthwatering meals from your own ingredients to help minimize food
        waste 🚯
      </p>
      <a
        href="https://t.me/ChowBuddyBot"
        className="bg-purple-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-purple-400 transition duration-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        Chat Now
      </a>
    </div>
  );
};

export default HeroSection;
